import { axios } from '@/lib/axios'
import { ApiResponse } from '../types'
import { Users } from './types'

type ApiUsersResponse = ApiResponse<Users>

export const getUsers = (): Promise<ApiUsersResponse> => {
  return axios.get(`/users`)
}
